
import {
  ArrowLeftIcon,
  CalendarDaysIcon,
  CheckCircleIcon,
  ClipboardDocumentCheckIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  IdentificationIcon,
  PhoneIcon,
  XCircleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import moment from 'moment'
import 'moment/locale/nl'
import { useLocation, useNavigate } from 'react-router-dom'
import { Attachments } from '../../../Componenten/Documenten/Attachments'
import VragenlijstenResumer from '../../../Componenten/Vragenlijsten/VragenlijstenResumer'
import { useLayoutEffect, useMemo, useState } from 'react'
import { AXIOS_GET } from '../../../server/api/crud'
import Commentaar from '../../../Componenten/Commentaar'
import { getUserdetails } from '../../../Localstorage/localstorage'
import RP_Avatar from '../../../Componenten/RP_Avatar'

moment.locale('nl')

  const eventTypes = {
    applied: { icon: XMarkIcon, bgColorClass: 'bg-red-400' },
    advanced: { icon: XMarkIcon, bgColorClass: 'bg-red-500' },
    completed: { icon: XMarkIcon, bgColorClass: 'bg-red-500' },
  }
  
  const timeline = [
    {
      id: 1,
      type: eventTypes.applied,
      content: 'Pre-intake formulier',
      target: 'Niet ingevuld',
      date: 'Sep 20',
      datetime: '2020-09-20',
    },
    {
      id: 2,
      type: eventTypes.advanced,
      content: 'Klachtenregistratie formulier',
      target: 'Niet ingevuld',
      date: 'Sep 22',
      datetime: '2020-09-22',
    },
    {
      id: 3,
      type: eventTypes.advanced,
      content: 'VoedingsDagboek formulier',
      target: 'Niet ingevuld',
      date: 'Sep 22',
      datetime: '2020-09-22',
    }
  ]

  const CalculateAge = ( birthDate ) => {
    if (!birthDate) return null
    return moment().diff(moment(birthDate, 'YYYY-MM-DD'), 'years')
  };

  const isSent = (value) => value === 1 || value === true || value === "1";

  const formatDate = (value, fallback = "Onbekend") => {
    if (!value) return fallback;
    const date = moment(value);
    return date.isValid() ? date.format("D MMMM YYYY") : fallback;
  };
  
  const DetailProfiel = () => {

    const usernav = useLocation();
    const navigate = useNavigate();
    const user = usernav?.state?.user;
    const [attachments, setAttachments] = useState([])

    const userAdmin = getUserdetails();

    const questionnaireStatus = useMemo(() => [
      {
        label: "Pre-intake",
        sent: isSent(user?.vragenlijsten_preintake_verstuur),
        icon: IdentificationIcon,
      },
      {
        label: "Klachtenregistratie",
        sent: isSent(user?.vragenlijsten_klacht_verstuur),
        icon: ClipboardDocumentCheckIcon,
      },
      {
        label: "Voedingsdagboek",
        sent: isSent(user?.vragenlijsten_voeding_verstuur),
        icon: DocumentTextIcon,
      },
    ], [
      user?.vragenlijsten_klacht_verstuur,
      user?.vragenlijsten_preintake_verstuur,
      user?.vragenlijsten_voeding_verstuur,
    ]);

    const completedQuestionnaires = questionnaireStatus.filter((item) => item.sent).length;
    const trajectPercent = Math.round((completedQuestionnaires / questionnaireStatus.length) * 100);
    const age = CalculateAge(user?.userdetails_date_of_birth);

    const infoItems = [
      {
        label: "E-mailadres",
        value: user?.userdetails_email || "-",
        icon: EnvelopeIcon,
      },
      {
        label: "Telefoon",
        value: user?.userdetails_phone_number || "-",
        icon: PhoneIcon,
      },
      {
        label: "Geboortedatum",
        value: formatDate(user?.userdetails_date_of_birth, "-"),
        icon: CalendarDaysIcon,
      },
      {
        label: "Lid sinds",
        value: formatDate(user?.created_at),
        icon: CheckCircleIcon,
        accent: true,
      },
    ];

    const getDocumentByID = async (p_user_id) =>{
      try {
        const res = await AXIOS_GET(`documents/user/${p_user_id}`)
        setAttachments(res?.data?.data || [])
      } catch (error) {
        console.error("Error fetching documents:", error);
        setAttachments([])
      }
    }

    useLayoutEffect(() => {
      if (!user?.user_id) return;
      void getDocumentByID(user.user_id);
    }, [user?.user_id])
    

  if (user) return (
        <div className="min-h-dvh bg-wa-app text-wa-text">
          <main className="px-4 py-5 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-7xl">
              <button
                type="button"
                onClick={() => navigate("/dashboard")}
                className="mb-4 inline-flex min-h-[44px] items-center gap-2 rounded-xl border border-wa-border bg-wa-panel px-3 text-sm font-semibold text-wa-muted transition duration-200 hover:-translate-y-0.5 hover:border-wa-accent/50 hover:text-wa-text focus:outline-none focus:ring-2 focus:ring-wa-accent"
              >
                <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" />
                Terug naar dashboard
              </button>

              <section className="overflow-hidden rounded-2xl border border-wa-border bg-wa-panel shadow-[0_22px_70px_-42px_rgba(0,0,0,0.8)]">
                <div className="grid gap-0 lg:grid-cols-[minmax(0,1fr)_20rem]">
                  <div className="relative overflow-hidden bg-gradient-to-br from-wa-panel via-wa-panel2 to-wa-panel px-5 py-6 sm:px-7 sm:py-7">
                    <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
                      <div className="flex min-w-0 items-center gap-4">
                        <div className="relative flex-shrink-0 rounded-full bg-wa-panel ring-2 ring-wa-border">
                          <RP_Avatar avatar={user?.userdetails_avatar} size={20} alt={user?.userdetails_full_name || "Client"} />
                          <span aria-hidden="true" className="absolute inset-0 rounded-full shadow-inner ring-1 ring-white/10" />
                        </div>
                        <div className="min-w-0">
                          <p className="text-sm font-semibold text-wa-accent">Repeat clientprofiel</p>
                          <h1 className="mt-1 text-2xl font-bold leading-tight text-wa-text sm:text-3xl">
                            {user?.userdetails_full_name || "Client"}
                          </h1>
                          <div className="mt-2 flex flex-wrap items-center gap-2 text-sm text-wa-muted">
                            {age !== null && (
                              <span className="rounded-full border border-wa-border bg-wa-panel2 px-3 py-1 font-medium text-wa-text">
                                {age} jaar
                              </span>
                            )}
                            <span>Persoonlijk overzicht van profiel, documenten, notities en vragenlijsten.</span>
                          </div>
                        </div>
                      </div>
                      <div className="rounded-2xl border border-wa-border bg-wa-panel/80 p-4 text-center shadow-inner sm:min-w-[160px]">
                        <p className="text-sm font-semibold text-wa-muted">Repeat traject</p>
                        <p className="mt-1 text-3xl font-bold text-wa-text">{trajectPercent}%</p>
                        <p className="mt-1 text-xs text-wa-muted">
                          {completedQuestionnaires}/{questionnaireStatus.length} formulieren verstuurd
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="border-t border-wa-border bg-wa-panel2/70 p-5 lg:border-l lg:border-t-0">
                    <p className="text-sm font-semibold text-wa-text">Volgende aandacht</p>
                    <p className="mt-2 text-sm leading-6 text-wa-muted">
                      Bekijk ontbrekende formulieren en vul de interne notities aan voor de volgende consultatie.
                    </p>
                  </div>
                </div>
              </section>
            </div>

            <div className="mx-auto mt-5 grid max-w-7xl grid-cols-1 gap-5 lg:grid-cols-[minmax(0,1fr)_22rem]">
              <div className="min-w-0 space-y-5">
                <section aria-labelledby="client-profile-title">
                  <div className="overflow-hidden rounded-2xl border border-wa-border bg-wa-panel shadow-[0_20px_60px_-42px_rgba(0,0,0,0.75)]">
                    <div className="border-b border-wa-border px-5 py-4 sm:px-6">
                      <h2
                        id="client-profile-title"
                        className="text-lg font-semibold leading-6 text-wa-text"
                      >
                        Gebruikersprofiel
                      </h2>
                      <p className="mt-1 max-w-2xl text-sm leading-6 text-wa-muted">
                        De belangrijkste contactgegevens en intakecontext van deze client.
                      </p>
                    </div>
                    <div className="space-y-5 px-5 py-5 sm:px-6">
                      <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                        {infoItems.map((item) => (
                          <div
                            key={item.label}
                            className="flex gap-3 rounded-xl border border-wa-border bg-wa-panel2/70 p-4"
                          >
                            <item.icon
                              className={`mt-0.5 h-5 w-5 flex-shrink-0 ${
                                item.accent ? "text-wa-accent" : "text-wa-muted"
                              }`}
                              aria-hidden="true"
                            />
                            <div className="min-w-0">
                              <dt className="text-xs font-semibold text-wa-muted">
                                {item.label}
                              </dt>
                              <dd className="mt-1 break-words text-sm font-semibold text-wa-text">
                                {item.value}
                              </dd>
                            </div>
                          </div>
                        ))}
                        <div className="rounded-xl border border-wa-border bg-wa-panel2/70 p-4">
                          <dt className="text-xs font-semibold text-wa-muted">
                            Hoofdklacht
                          </dt>
                          <dd className="mt-1 break-words text-sm font-semibold text-wa-text">
                            {user?.userdetails_klacht || "-"}
                          </dd>
                        </div>
                        <div className="sm:col-span-2">
                          <dt className="text-xs font-semibold text-wa-muted">
                            Situatie
                          </dt>
                          <dd className="mt-2 whitespace-pre-wrap rounded-xl border border-wa-border bg-wa-panel2/60 p-4 text-sm leading-6 text-wa-text">
                            {user?.userdetails_more_details || "Geen extra informatie ingevuld."}
                          </dd>
                        </div>
                      </dl>
                    </div>
                  </div>
                </section>

                <section aria-labelledby="documents-title">
                  <div className="overflow-hidden rounded-2xl border border-wa-border bg-wa-panel shadow-[0_20px_60px_-42px_rgba(0,0,0,0.75)]">
                    <div className="flex items-center justify-between gap-3 border-b border-wa-border px-5 py-4 sm:px-6">
                      <div>
                        <h2 id="documents-title" className="text-lg font-semibold text-wa-text">
                          Documenten
                        </h2>
                        <p className="mt-1 text-sm text-wa-muted">
                          Bestanden gekoppeld aan dit clientprofiel.
                        </p>
                      </div>
                      <span className="rounded-full bg-wa-panel2 px-3 py-1 text-xs font-semibold text-wa-muted">
                        {attachments?.length || 0}
                      </span>
                    </div>
                    <div className="px-5 py-5 sm:px-6">
                      {attachments?.length > 0 ? (
                        <Attachments attachments={attachments} />
                      ) : (
                        <div className="rounded-xl border border-dashed border-wa-border bg-wa-panel2/50 p-5 text-sm text-wa-muted">
                          Er zijn nog geen documenten toegevoegd.
                        </div>
                      )}
                    </div>
                  </div>
                </section>

                <Commentaar admin={userAdmin} user={user} />
              </div>

              <aside className="space-y-5">
                <section className="rounded-2xl border border-wa-border bg-wa-panel p-5 shadow-[0_20px_60px_-42px_rgba(0,0,0,0.75)]">
                  <div className="flex items-center justify-between gap-3">
                    <div>
                      <h2 className="text-lg font-semibold text-wa-text">Trajectstatus</h2>
                      <p className="mt-1 text-sm text-wa-muted">Repeat formulieren</p>
                    </div>
                    <div className="rounded-2xl border border-wa-border bg-wa-panel2 px-3 py-2 text-right">
                      <p className="text-lg font-bold text-wa-text">{trajectPercent}%</p>
                    </div>
                  </div>
                  <div className="mt-4 h-2 overflow-hidden rounded-full bg-wa-panel2">
                    <div
                      className="h-full rounded-full bg-wa-accent transition-all duration-300"
                      style={{ width: `${trajectPercent}%` }}
                    />
                  </div>
                  <div className="mt-5 space-y-3">
                    {questionnaireStatus.map((item) => (
                      <div key={item.label} className="flex items-center gap-3 rounded-xl border border-wa-border bg-wa-panel2/60 p-3">
                        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-wa-panel">
                          <item.icon className="h-5 w-5 text-wa-muted" aria-hidden="true" />
                        </div>
                        <div className="min-w-0 flex-1">
                          <p className="text-sm font-semibold text-wa-text">{item.label}</p>
                          <p className="text-xs text-wa-muted">
                            {item.sent ? "Verstuurd" : "Nog nodig"}
                          </p>
                        </div>
                        {item.sent ? (
                          <CheckCircleIcon className="h-5 w-5 text-wa-accent" aria-label="Verstuurd" />
                        ) : (
                          <XCircleIcon className="h-5 w-5 text-wa-muted" aria-label="Nog nodig" />
                        )}
                      </div>
                    ))}
                  </div>
                </section>

                <VragenlijstenResumer
                  timeline={timeline}
                  vragenlijst={{
                    klacht_verstuur: user?.vragenlijsten_klacht_verstuur,
                    preintake_verstuur: user?.vragenlijsten_preintake_verstuur,
                    voeding_verstuur: user?.vragenlijsten_voeding_verstuur,
                  }}
                  user={user}
                />
              </aside>
            </div>
          </main>
        </div>
    )

    return(
      <div className="min-h-dvh bg-wa-app px-4 py-10 text-wa-text sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl rounded-2xl border border-wa-border bg-wa-panel p-6 text-center shadow-[0_20px_60px_-42px_rgba(0,0,0,0.75)]">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-wa-panel2">
            <IdentificationIcon className="h-7 w-7 text-wa-muted" aria-hidden="true" />
          </div>
          <h1 className="mt-4 text-2xl font-bold text-wa-text">Geen client geselecteerd</h1>
          <p className="mt-2 text-sm leading-6 text-wa-muted">
            Open eerst een client vanuit het dashboard om het Repeat clientprofiel te bekijken.
          </p>
          <button
            type="button"
            onClick={() => navigate("/dashboard")}
            className="mt-5 inline-flex min-h-[44px] items-center justify-center gap-2 rounded-xl bg-wa-accent px-4 text-sm font-semibold text-wa-onaccent transition duration-200 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-wa-accent"
          >
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" />
            Terug naar dashboard
          </button>
        </div>
      </div>
    )
  }

  export default DetailProfiel
